// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { error } from 'react-notification-system-redux'

const settingsFailedToLoadMessage = (d, err = {}) => dispatch => (
  dispatch(error({
    title: `${d} Settings Error`,
    message: err.message || `There was an error when loading ${d} Settings. This will cause the application to behave unexpectedly. Please reload the page.`,
    dismissible: false,
    autoDismiss: 0,
    action: {
      label: 'Reload page.',
      callback: () => window.location.reload(),
    },
  }))
)

export default settingsFailedToLoadMessage
